function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 500 500",
    width: "1em",
    height: "1em",
    className: "svg-icon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path--inject-3"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 174.41,
    y: 112.08,
    width: 167.9,
    height: 302.59,
    rx: 6.75,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M342,387s48-3,81-62,27-149-14-199S304,59,243,75c-29.72,7.79-49.54,28-66.67,52.38-14.92,21.24-31.7,41.7-54.28,55.14-22.36,13.3-45.35,23.92-56.64,49.2C37.93,293.28,58,364.88,123,389,193,415,310,401,342,387Z",
    style: {
      fill: "#9EBBF6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342,387s48-3,81-62,27-149-14-199S304,59,243,75c-29.72,7.79-49.54,28-66.67,52.38-14.92,21.24-31.7,41.7-54.28,55.14-22.36,13.3-45.35,23.92-56.64,49.2C37.93,293.28,58,364.88,123,389,193,415,310,401,342,387Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Ground--inject-3"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 255.17,
    cy: 416.02,
    rx: 170.83,
    ry: 15,
    style: {
      fill: "#9EBBF6"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 255.17,
    cy: 416.02,
    rx: 170.83,
    ry: 15,
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Graphics--inject-3"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 80.97,
    y1: 226.3,
    x2: 80.97,
    y2: 235.17,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 85.41,
    y1: 230.74,
    x2: 76.54,
    y2: 230.74,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 383.64,
    y1: 150.3,
    x2: 383.64,
    y2: 159.17,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 388.07,
    y1: 154.74,
    x2: 379.2,
    y2: 154.74,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 257.64,
    y1: 81.64,
    x2: 257.64,
    y2: 90.51,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 262.07,
    y1: 86.07,
    x2: 253.2,
    y2: 86.07,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 111.64,
    y1: 325.64,
    x2: 111.64,
    y2: 334.51,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 116.07,
    y1: 330.07,
    x2: 107.2,
    y2: 330.07,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.67,118.33a7.34,7.34,0,1,1-7.34-7.33A7.34,7.34,0,0,1,379.67,118.33Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 63,
    cy: 287.67,
    r: 7.33,
    transform: "translate(-105.29 46.01) rotate(-22.5)",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413,193.33a1.67,1.67,0,1,1-3.33,0,1.67,1.67,0,0,1,3.33,0Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.67,169.33a1.67,1.67,0,1,1-1.67-1.66A1.67,1.67,0,0,1,158.67,169.33Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M438.92,267.67l0-.05h-.06l0-.05,0,0c-1.39-.14-15.78-1.37-28.91,5.45a35.19,35.19,0,0,0,7.44-25.83c-3.17-31.7-33.08-49.84-35.39-51.2V196l-.07,0-.07,0V196c-2.31,1.36-32.22,19.5-35.39,51.2a35.28,35.28,0,0,0,2.74,18c-16.84-10.07-36.48-8.37-38.29-8.19l0-.06,0,.07h-.07l0,.05c-.89,2.05-12.13,29.08,1.37,52.05,12.08,20.54,37.41,15.11,44.29,13.18,5.78,6.07,16.32,19.89,21,43.47h-6.56L374,410.49h14.76L392,365.83h-7.73a136.5,136.5,0,0,1,18.86-44.92c6.89,1.72,25.53,4.62,34.72-11C448.77,291.26,439.65,269.34,438.92,267.67Zm-57.46-.17-15.6-21.67a.42.42,0,0,1,.09-.59.43.43,0,0,1,.6.09l14.94,20.75V244.13l0,0-15.6-21.66a.43.43,0,0,1,.09-.6.44.44,0,0,1,.6.1l14.94,20.75v-32a.42.42,0,0,1,.42-.42.42.42,0,0,1,.42.42v30.89l16.2-20.54a.42.42,0,0,1,.67.52l-16.87,21.39v22l16.2-20.55a.43.43,0,0,1,.6-.07.42.42,0,0,1,.07.59l-16.87,21.4V285l16.2-20.54a.42.42,0,0,1,.67.52l-16.87,21.39v.41H381l-15.09-21a.43.43,0,0,1,.09-.6.44.44,0,0,1,.6.1L381.49,286V267.46Zm-24.79,52.89-1.53-2.1-22-6.12a.37.37,0,0,1-.24-.44.36.36,0,0,1,.44-.25l21.08,5.88-9.17-12.54-22-6.12a.36.36,0,0,1-.25-.44.37.37,0,0,1,.44-.24l21.09,5.88-10.84-14.84-22-6.12a.34.34,0,0,1-.24-.43.35.35,0,0,1,.43-.25l21.09,5.88-15.25-20.86a.36.36,0,0,1,.08-.5.34.34,0,0,1,.49.08l15.78,21.58L334,267.05a.37.37,0,0,1,.36-.36.36.36,0,0,1,.35.36l.16,22.33h0l10.84,14.83-.16-21.39a.36.36,0,1,1,.71,0l.16,22.34h0l9.16,12.53-.16-21.39a.36.36,0,0,1,.36-.35.35.35,0,0,1,.35.35l.16,22.34h0l1.31,1.79Zm2.5,0c3.2-4.87,12.44-20.86,6.92-36.25a69.72,69.72,0,0,0,13.69,7v69.44c-5.07-21.28-14.61-34-20.43-40.19Zm24,35.91V291.46a69.34,69.34,0,0,0,13.09-6.38c-8.81,14.12,1.06,30.43,3.66,34.28A135.77,135.77,0,0,0,383.17,356.3Zm54.92-67.69-17.81,5-8.8,12,17.11-4.77a.28.28,0,0,1,.36.2.29.29,0,0,1-.2.35l-17.81,5-7.44,10.17,17.11-4.77a.29.29,0,0,1,.35.2.3.3,0,0,1-.2.36l-17.81,5-.94,1.28c-.17-.1-.33-.19-.49-.3l.53-.73h0l.14-18.12a.29.29,0,1,1,.57,0l-.12,17.36L410,306.62h0l.13-18.12a.28.28,0,0,1,.29-.28.29.29,0,0,1,.29.29l-.13,17.35,8.8-12h0l.13-18.12a.29.29,0,0,1,.29-.29.28.28,0,0,1,.28.29l-.12,17.35,12.8-17.51a.29.29,0,0,1,.4-.06.28.28,0,0,1,.06.4l-12.37,16.93,17.11-4.77a.29.29,0,0,1,.35.2A.27.27,0,0,1,438.09,288.61Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-3"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 179.74,
    y: 112.08,
    width: 167.9,
    height: 302.59,
    rx: 6.75,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 174.41,
    y: 112.08,
    width: 167.9,
    height: 302.59,
    rx: 6.75,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path--inject-3)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M342.31,226.26,194.67,414.68h140.9a6.75,6.75,0,0,0,6.74-6.75Z",
    style: {
      fill: "#9EBBF6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.31,226.26,194.67,414.68h140.9a6.75,6.75,0,0,0,6.74-6.75Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 174.41,
    y: 112.08,
    width: 167.9,
    height: 302.59,
    rx: 6.75,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270,130.16h-20.9a2.15,2.15,0,0,1-2.15-2.15h0a2.14,2.14,0,0,1,2.15-2.14H270a2.14,2.14,0,0,1,2.14,2.14h0A2.14,2.14,0,0,1,270,130.16Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.7,387.63H185V130.41h34.77l3.91,3.24a7.6,7.6,0,0,0,4.86,1.76h61.35a7.61,7.61,0,0,0,5-1.9l3.54-3.1H331.7Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 212.54,
    y1: 332.17,
    x2: 304.18,
    y2: 332.17,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 212.54,
    y1: 344.23,
    x2: 304.18,
    y2: 344.23,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 212.54,
    y1: 356.29,
    x2: 304.18,
    y2: 356.29,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221,220.2a45.35,45.35,0,1,0,37.33-19.59,46.22,46.22,0,0,0-8.29.75",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.73,211.63a46.5,46.5,0,0,0-4.3,4.24",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 258.36,
    cy: 245.95,
    r: 38.48,
    transform: "translate(-69.16 387.29) rotate(-66.93)",
    style: {
      fill: "#9EBBF6"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "240.59 241.97 255.19 258.56 279.07 224.73",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 6
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.93,133.51a7.61,7.61,0,0,1-5,1.9H228.56a7.6,7.6,0,0,1-4.86-1.76l-3.91-3.24H185v26.31H331.7V130.41H298.47Z",
    style: {
      fill: "#9EBBF6",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.05,395.56a3.34,3.34,0,1,0-3.33,3.33A3.34,3.34,0,0,0,263.05,395.56Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M132.58,293.26l-13.08,117s-9.59,8.34-8.75,11.71,11.91-2,13.44-4.78a28.85,28.85,0,0,0,2.3-7.28l27.54-88,21.18,94.37s9,7.39,14,7.14,3.22-2.22.37-5.83-9.3-5.67-9.3-5.67l-3.18-121.63Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 132.56,
    y: 289.36,
    width: 44,
    height: 6,
    transform: "translate(-14.64 8.22) rotate(-2.91)",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.7,292.05c.07,1.49-1.82,2.79-4.24,2.92S151,294,151,292.5s1.83-2.79,4.24-2.91S159.62,290.57,159.7,292.05Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "152.17 230.57 135.65 235.41 137.7 290.63 176.45 289.67 171.55 232.59 152.17 230.57",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "144.94 231.19 142.72 325.42 121.68 315.23 130.93 285.47 124.62 235.22 144.94 231.19",
    style: {
      fill: "#9EBBF6",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "161.67 230.34 173.43 323.86 193.34 311.59 181.12 282.92 182.3 232.29 161.67 230.34",
    style: {
      fill: "#9EBBF6",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "149.15 241.74 152.43 247.08 149.81 284.26 156.03 291.62 159.25 282.78 154.27 247.15 157.34 241.99 152.88 236.21 149.15 241.74",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "153.21 241.03 147.02 245.69 142.06 233.59 144.85 229.27 160 228.5 163.58 233.33 160.63 244.33 153.21 241.03",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "146.11 224.62 147.5 232.31 153.21 241.03 158.44 230.75 158.11 224.26 146.11 224.62",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "124.62 235.22 96.56 269.19 115.21 291.27 122.72 286.39 113.5 267.58 127.26 257.62 124.62 235.22",
    style: {
      fill: "#9EBBF6",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "122.72 286.39 123.84 288.83 117.52 292.41 116.67 290.45 122.72 286.39",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.84,288.83l6.44,8.44-2.12,2.61-1.54-.67-3.12,2.66s-2.28-.64-2.57-1.37-3.38-2.59-3.45-3.83,0-4.26,0-4.26Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.93,238.92a5.47,5.47,0,0,0,.24-3.11c-.46-1.19-1.48-5.31-1.28-6.67s2.26-3.34,2.44-5.1,0-3.37,0-4.32a1.21,1.21,0,0,1,2.26-.52c1,1.16,1.6,2.35,1.12,3.58a17.05,17.05,0,0,0-.46,4.2s1.6,2.21,2.48,3.65.8,5.21.21,6.72a9.41,9.41,0,0,1-2.28,3l.1,2.6Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.85,224.9s-.7,2.06.53,2.53,6.26,1.17,6.31-.45.15-2.43-.66-2.39-4.58,0-4.58,0S200.7,224.5,200.85,224.9Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.42,235s-.5,1.53.39,1.88,4.51.88,4.54-.33.1-1.81-.48-1.78-3.3,0-3.3,0S201.31,234.68,201.42,235Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.75,231.73s-.58,1.78.45,2.19,5.22,1,5.26-.38.12-2.1-.56-2.07-3.82,0-3.82,0S200.62,231.39,200.75,231.73Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.36,228.56s-.7,2.06.54,2.53,6.25,1.17,6.3-.45.15-2.43-.66-2.39-4.58,0-4.58,0S200.21,228.17,200.36,228.56Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "197.36 240.97 198.14 237.83 203.56 241.06 202.65 244.47 197.36 240.97",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.3,232.29l10.38,22.09,5.1-14.21,5,4.76-5.12,26.34a4.24,4.24,0,0,1-7.6,1.66l-8.29-11.57Z",
    style: {
      fill: "#9EBBF6",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.28,215.64s-2.1-2.24-2.37-.6.58,4.47,1.9,5.48,2.48-.66,2.48-.66Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.13,214.63s1.85-2.44,2.3-.84-.13,4.51-1.34,5.65-2.54-.41-2.54-.41Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.12,217.94l-2-4.23a19.78,19.78,0,0,1-3.27-7.57c-1-4.64.65-8.5,2.75-9.69a5.78,5.78,0,0,1,3.93-.74s.4-2.72,7-5,13.78,1.83,13.67,3.27-1.87,2.08-1.87,2.08,5.14,1.9,3.28,4.33a11.8,11.8,0,0,1-4.33,3.47,34.28,34.28,0,0,1,.91,3.73c.26,1.61-1.19,8.53-1.19,8.53l-3.55-9.73-11.14.57s-.66,4.72-1.84,6.4a8.81,8.81,0,0,0-1.22,4.2S142.73,219.34,142.12,217.94Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.1,200.36a66.09,66.09,0,0,1-.63,8.68,6.53,6.53,0,0,1-2.32,4.08s1.42,6.59,3.22,10.1,5.54,6.39,9.31,6,6.78-4.67,7.14-8.29-1.41-17-1.41-17S147.63,206,144.1,200.36Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.1,213.89a4.3,4.3,0,0,1,4-.2",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.94,210.89s.23-2,3.57-2.18",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.83,208.27a3.82,3.82,0,0,1,4.4,1.11",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.66,211.5s.53,4,.56,4.49,1.7.58,1.25,1.6-1.9,2.1-3.11,1.33",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.54,222.27s-1.27,1.23-3.83.19",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.07,212.78c0,.74-.31,1.36-.77,1.38s-.86-.56-.9-1.29.31-1.35.77-1.38S157,212.05,157.07,212.78Z",
    style: {
      fill: "#263238"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/Success.7941f636ed826417cb422316b357f987.svg";
export { ForwardRef as ReactComponent };